import type { MessageKey } from "./ru"

export const urMessages = {
  "common.loading": "لوڈ ہو رہا ہے...",
  "common.error": "خرابی",
  "common.back": "واپس",
  "common.next": "اگلا",
  "common.search": "تلاش",
  "auth.loginErrorTitle": "لاگ اِن کی خرابی",
  "auth.openViaTelegram": "ایپ Telegram کے ذریعے کھولیں",
  "auth.telegramRequired": "ایپ کو Telegram کے ذریعے کھولا جانا چاہیے",
  "auth.authorizationError": "اجازت کی خرابی",
  "device.rotatePortrait": "اپنے آلے کو عمودی حالت میں کریں",
  "country.brazil": "برازیل",
  "country.vietnam": "ویتنام",
  "country.egypt": "مصر",
  "country.india": "بھارت",
  "country.indonesia": "انڈونیشیا",
  "country.iran": "ایران",
  "country.spain": "اسپین",
  "country.italy": "اٹلی",
  "country.kazakhstan": "قازقستان",
  "country.colombia": "کولمبیا",
  "country.malaysia": "ملائیشیا",
  "country.mexico": "میکسیکو",
  "country.nigeria": "نائجیریا",
  "country.pakistan": "پاکستان",
  "country.russia": "روس",
  "country.usa": "امریکہ",
  "country.turkey": "ترکیہ",
  "country.uzbekistan": "ازبکستان",
  "country.ukraine": "یوکرین",
  "country.philippines": "فلپائن",
  "countrySelection.chooseCountry": "ملک منتخب کریں",
  "countrySelection.openAria": "ملک منتخب کریں",
  "languageSelection.chooseLanguage": "زبان منتخب کریں",
  "commercial.direction.autotrade": "آٹو مارکیٹ",
  "commercial.direction.insurance": "انشورنس",
  "commercial.direction.pitstop": "سروس سینٹر",
  "commercial.direction.techhelp": "روڈ سائیڈ مدد",
  "commercial.searchLabel": "BeepApp تلاش",
  "commercial.cityPlaceholder": "شہر درج کریں",
  "commercial.emptyTitle": "آج کوئی پیشکش نہیں",
  "commercial.emptyLine1": "آپ کے شہر میں ابھی کوئی فعال BeepApp پارٹنر نہیں ہے",
  "commercial.emptyLine2": "ہم انہیں تلاش کرنے اور جوڑنے پر کام کر رہے ہیں",
  "commercial.emptyLine3": "نئی پیشکشیں یہاں خودکار طور پر ظاہر ہوں گی",
  "commercial.helperLine1": "دستیاب پیشکشیں دیکھنے کے لیے",
  "commercial.helperLine2": "اپنا شہر درج کریں",
  "commercial.partnerPrompt": "BeepApp پارٹنر بننا چاہتے ہیں؟",
  "commercial.apply": "درخواست دیں",
  "main.admin": "ایڈمن",
  "main.garage": "گیراج",
  "main.signalSent": "سگنل بھیج دیا گیا",
  "main.partnerInviteUnavailable": "پارٹنر دعوت دستیاب نہیں",
  "main.enterPlate": "نمبر پلیٹ درج کریں",
  "main.searchError": "تلاش کی خرابی",
  "main.signalSendError": "سگنل بھیجا نہیں جا سکا",
  "main.shareCardPrefix": "نمبر پلیٹ کارڈ",
  "main.shareLinkError": "لنک تیار نہیں ہو سکا",
  "main.searchByPlateAria": "نمبر پلیٹ سے تلاش",
  "main.russianPlateAria": "روسی نمبر پلیٹ",
  "main.plateAria": "نمبر پلیٹ",
  "main.findPlateAria": "نمبر پلیٹ تلاش کریں",
  "main.loadingVehicle": "نمبر پلیٹ کارڈ لوڈ ہو رہا ہے…",
  "main.leaveSignal": "سگنل بھیجیں",
  "main.share": "شیئر کریں",
  "signalSelection.chooseType": "سگنل کی قسم منتخب کریں",
  "signalSelection.category.attention": "ذاتی",
  "signalSelection.category.road": "سڑک",
  "signalSelection.category.urgent": "فوری",
  "signalSelection.chooseSignal": "سگنل منتخب کریں",
  "signalSelection.suggestOwn": "اپنی تجویز دیں",
  "signalConfirmation.title": "سگنل کی تصدیق",
  "signalConfirmation.plateHeading": "نمبر پلیٹ چیک کریں",
  "signalConfirmation.signalHeading": "منتخب سگنل چیک کریں",
  "signalConfirmation.replyTitle": "Telegram میں جواب کی اجازت دیں",
  "signalConfirmation.replyBody": "یہ آپشن فعال کریں تاکہ نمبر پلیٹ کا مالک\nآپ کو Telegram پر پیغام بھیج سکے۔ جواب صرف تب ممکن ہے جب\nآپ کے پاس @username ہو۔ جواب دینا یا نہ دینا\nنمبر پلیٹ کے مالک کی مرضی ہے۔",
  "signalConfirmation.consentText": "میں تصدیق کرتا ہوں کہ یہ سگنل\nحقیقی صورتحال کے مطابق ہے اور اسپام\nیا جھوٹی اطلاع نہیں ہے۔",
  "signalConfirmation.warning": "بھیجنے کے بعد سگنل\nتبدیل نہیں کیا جا سکتا",
  "signalConfirmation.sending": "بھیجا جا رہا ہے…",
  "signalConfirmation.send": "بھیجیں",
  "partner.loadingAria": "لوڈ ہو رہا ہے",
  "partner.title": "پارٹنر پروگرام",
  "partner.offerLine1": "تمام ادائیگیوں پر بغیر مدت کی حد کے 30% کمائیں",
  "partner.offerLine2": "ان صارفین سے جنہیں آپ BeepApp میں مدعو کریں",
  "partner.offerLine3": "Telegram affiliate پروگرام کے ذریعے",
  "partner.connectUnavailable": "Telegram Affiliate پروگرام کی ترتیب کے بعد کنکشن دستیاب ہوگا۔",
  "partner.connectTelegram": "Telegram میں کنیکٹ کریں",
  "partner.qrAria": "پارٹنر لنک QR کوڈ",
  "partner.download": "ڈاؤن لوڈ",
  "partner.promoHeading": "ذاتی پرومو کوڈ بنائیں",
  "partner.promoHelperLine1": "پرومو کوڈ ایک اضافی سال کی سبسکرپشن فعال کرتا ہے",
  "partner.promoHelperLine2": "اور صارفین لانے میں مدد کرتا ہے",
  "partner.promoAria": "پرومو کوڈ",
  "partner.affiliateHeading": "آپ کا affiliate لنک",
  "partner.affiliateHelper": "ذاتی QR کوڈ بنانے کے لیے لنک محفوظ کریں",
  "partner.affiliateAria": "Affiliate لنک",
  "partner.qrNoteLine1": "QR کوڈ گاڑی پر لگایا جا سکتا ہے،",
  "partner.qrNoteLine2": "سوشل میڈیا اور اشتہاری مواد میں بھی",
  "partner.save": "محفوظ کریں",
  "partner.reset": "ری سیٹ",
  "partner.resetConfirm": "محفوظ affiliate لنک ری سیٹ کریں؟ پرومو کوڈ آپ کے پاس رہے گا۔",
  "partner.promoFormatError": "پرومو کوڈ میں 4 سے 15 حروف ہونے چاہئیں۔",
  "partner.affiliateHostError": "صرف t.me یا telegram.me لنکس کی اجازت ہے۔",
  "partner.affiliatePathError": "لنک میں Telegram راستہ موجود نہیں۔",
  "partner.affiliateFormatError": "Affiliate لنک درست نہیں۔",
  "partner.loadError": "لوڈ کی خرابی",
  "partner.checkInputError": "درج کی گئی معلومات چیک کریں",
  "garageActivation.promoInvalid": "پرومو کوڈ درست نہیں",
  "garageActivation.plateOccupied": "یہ نمبر پلیٹ پہلے سے منسلک ہے",
  "garageActivation.activateError": "گیراج فعال نہیں ہو سکا",
  "garageEntry.loadJournalError": "لاگ بک لوڈ نہیں ہو سکی",
  "garageEntry.loadStatusesError": "اسٹیٹس لوڈ نہیں ہو سکے",
  "garageEntry.activationSuccess": "گیراج کامیابی سے فعال ہو گیا",
  "garageEntry.plateAttached": "نمبر پلیٹ منسلک ہو گئی",
  "garageEntry.attachError": "نمبر پلیٹ منسلک نہیں ہو سکی",
  "garageEntry.activationNote": "اپنا گیراج فعال کریں",
  "garageSheet.activationTitle": "گیراج فعال کرنا",
  "garageSheet.plateHelper": "گاڑی کی نمبر پلیٹ درج کریں",
  "garageSheet.promoHelper": "کیا آپ کے پاس پرومو کوڈ ہے؟",
  "garageSheet.cleanBonusLine1": "فعال ہونے کے بعد آپ کے پاس 1 گھنٹہ ہوگا",
  "garageSheet.cleanBonusLine2": "مفت «کلین اسٹارٹ» کے لیے",
  "garageSheet.activationFor": "فعال مدت",
  "garageSheet.cost": "قیمت",
  "garageSheet.ownerConsentLine1": "میں تصدیق کرتا ہوں کہ میں",
  "garageSheet.ownerConsentLine2": "درج شدہ نمبر پلیٹ والی",
  "garageSheet.ownerConsentLine3": "گاڑی کا مالک ہوں۔",
  "garageSheet.processing": "عمل جاری ہے...",
  "garageSheet.attach": "منسلک کریں",
  "garageSheet.pay": "ادائیگی کریں",
  "garageLifecycle.cleanTitle": "کلین اسٹارٹ",
  "garageLifecycle.deactivateTitle": "گیراج غیر فعال کرنا",
  "garageLifecycle.cleanWarningLine1": "نمبر پلیٹ کی تاریخ حذف ہو جائے گی",
  "garageLifecycle.cleanWarningLine2": "اور واپس بحال نہیں کی جا سکے گی!",
  "garageLifecycle.deactivateWarningLine1": "غیر فعال کرنے کے بعد فعال",
  "garageLifecycle.deactivateWarningLine2": "گیراج کی خصوصیات تک رسائی ختم ہو جائے گی",
  "garageLifecycle.willBeDeleted": "حذف ہو جائے گا",
  "garageLifecycle.cleanRemovedLine1": "• لاگ بک کی تمام اندراجات",
  "garageLifecycle.cleanRemovedLine2": "• موصولہ سگنلز کی تاریخ",
  "garageLifecycle.cleanRemovedLine3": "• عوامی سگنل کاؤنٹرز",
  "garageLifecycle.cleanRemovedLine4": "  نمبر پلیٹ کارڈ پر",
  "garageLifecycle.willRemain": "برقرار رہے گا",
  "garageLifecycle.cleanPreservedLine1": "• نمبر پلیٹ کا گیراج سے تعلق",
  "garageLifecycle.cleanPreservedLine2": "• باقی فعال مدت",
  "garageLifecycle.cleanPreservedLine3": "• منتخب نمبر پلیٹ اسٹیٹس",
  "garageLifecycle.cleanPreservedLine4": "• نمبر پلیٹ کارڈ کے کل ویوز",
  "garageLifecycle.freeFirstHour": "پہلے گھنٹے میں مفت",
  "garageLifecycle.willBecomeUnavailable": "دستیاب نہیں رہے گا",
  "garageLifecycle.deactivateRemovedLine1": "• لاگ بک",
  "garageLifecycle.deactivateRemovedLine2": "• نمبر پلیٹ اسٹیٹس کا انتخاب اور استعمال",
  "garageLifecycle.deactivateRemovedLine3": "• آپ خودکار طور پر «AutoClan» چھوڑ دیں گے",
  "garageLifecycle.deactivateRemovedLine4": "• آٹو مارکیٹ",
  "garageLifecycle.deactivateRemovedLine5": "• انشورنس",
  "garageLifecycle.deactivateRemovedLine6": "• سروس سینٹر",
  "garageLifecycle.deactivateRemovedLine7": "• روڈ سائیڈ مدد",
  "garageLifecycle.deactivateRemovedLine8": "• نمبر پلیٹ گیراج سے الگ ہو جائے گی",
  "garageLifecycle.willRemainAvailable": "دستیاب رہے گا",
  "garageLifecycle.deactivatePreservedLine1": "• ساتھی",
  "garageLifecycle.deactivatePreservedLine2": "• ڈسپیچر",
  "garageLifecycle.deactivatePreservedLine3": "• نمبر پلیٹ سے تلاش اور",
  "garageLifecycle.deactivatePreservedLine4": "  عوامی گاڑی کارڈ دیکھنا",
  "garageLifecycle.deactivatePreservedLine5": "• کسی بھی وقت گیراج",
  "garageLifecycle.deactivatePreservedLine6": "  دوبارہ فعال کرنے کی سہولت",
  "garageLifecycle.cleanConsentLine1": "میں اس نمبر پلیٹ کی",
  "garageLifecycle.cleanConsentLine2": "تمام تاریخ حذف کرنے کی",
  "garageLifecycle.cleanConsentLine3": "بغیر بحالی کے رضامندی دیتا ہوں۔",
  "garageLifecycle.deactivateConsentLine1": "میں غیر فعال کرنے اور",
  "garageLifecycle.deactivateConsentLine2": "تمام فعال گیراج خصوصیات تک",
  "garageLifecycle.deactivateConsentLine3": "رسائی ختم کرنے کی تصدیق کرتا ہوں۔",
  "garageLifecycle.clean": "صاف کریں",
  "garageLifecycle.deactivate": "غیر فعال کریں",
} satisfies Record<MessageKey, string>
